import { useState, useEffect } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { NavLink, useLocation } from 'react-router-dom';
import { CrossIcon, RouteIcons } from '../../assets/icons';
import Button from '../../components/Button';
import { BasePath } from '../../config/constants';

const sidebarLinks = [
    {
        label: 'Home',
        to: BasePath.HOME,
        routeIcon: RouteIcons[BasePath.HOME],
    },
    {
        label: 'Referrals',
        to: BasePath.REFERRALS,
        routeIcon: RouteIcons[BasePath.REFERRALS],
    },
    {
        label: 'Pools',
        to: BasePath.POOLS,
        routeIcon: RouteIcons[BasePath.POOLS],
    },
    {
        label: 'Trade',
        to: `${BasePath.TRADE}/BTCUSD`,
        routeIcon: RouteIcons[BasePath.TRADE],
    },
    {
        label: 'Analytics',
        to: BasePath.ANALYTICS,
        routeIcon: RouteIcons[BasePath.ANALYTICS],
    },
    {
        label: 'Leaderboard',
        to: BasePath.LEADERBOARD,
        routeIcon: RouteIcons[BasePath.LEADERBOARD],
    },
];

type SidebarProps = {
    isOpen: boolean;
    handleClose: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ isOpen, handleClose }) => {
    const [visibility, setVisibility] = useState(false);

    const location = useLocation();

    const handleTransitionEnd = () => {
        setVisibility(isOpen);
    };

    useEffect(() => {
        const escapeListener = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };

        window.addEventListener('keydown', escapeListener);

        return () => window.removeEventListener('keydown', escapeListener);
    }, [isOpen, handleClose]);

    return (
        <ClickAwayListener onClickAway={handleClose}>
            <aside
                className={`sidebar ${isOpen ? 'collapsed' : ''}`}
                style={{
                    visibility: isOpen || visibility ? 'visible' : 'hidden',
                }}
                tabIndex={isOpen ? 1 : -1}
                aria-hidden={!isOpen}
                onTransitionEnd={handleTransitionEnd}
            >
                <nav>
                    {sidebarLinks.map(({ label, to, routeIcon }, index) => (
                        <NavLink
                            key={index}
                            to={to}
                            onClick={handleClose}
                            tabIndex={location.pathname === to ? -1 : 0}
                        >
                            <div className='icon-container'>{routeIcon}</div>
                            <span>{label}</span>
                        </NavLink>
                    ))}
                </nav>
                <Button onClick={handleClose}>
                    <CrossIcon />
                </Button>
            </aside>
        </ClickAwayListener>
    );
};

export default Sidebar;
